<template>
  <div class="zj-emergency-videomonitor-container">
    <div class="video-wrapper">
      <videoItem ref="onePlayer" :videoIndex="cameraId" :streamUrl="streamUrl" :cameraName="cameraName"></videoItem>
      <!-- <zj-camera-preview
        class="video-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :autoplay="autoplay"
      /> -->
    </div>
    <div class="video-title">
      {{cameraName}}
      <div class="video-item-spread" @click="handleSpread"></div>
    </div>
  </div>
</template>
 
<script>
import videoItem from "./hlsPlayer.vue"
import dataServerApi from "../../../../../../../request/dataServerApi";
export default {
  name: "ZJEmergencyVideoMonitorPanel",
  componentName: "ZJEmergencyVideoMonitorPanel",
  components:{
    videoItem
  },
  props: {
    cameraId: String,
    cameraName: String,
    streamUrl: String,
    autoplay:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    cameraId:function(val){
      console.log("cameraId")
      console.log(val)
      console.log(this.streamUrl)
      // this.getStreamUrlByCode(val);
    }
  },
  methods:{
    handleSpread(){
      this.$emit("spread",this.cameraId,this.cameraName,this.streamUrl);
    },
    getStreamUrlByCode(code,index) {
      let params= {"indexCode":code}
      // let params= {"indexCode":"865ac4e15d0947d7bec6349ddf380f2d"}
      dataServerApi.getstreamurl(params).then(res=>{
        console.log(res)
        if(res.code==0){
          let streamUrl = res.data.data.url;
          this.streamUrl =streamUrl;
          console.log("streamUrl")
          console.log(streamUrl)
          console.log(this.cameras)
        }
      })
    },
  }
};
</script>